<template>
  <header class="masthead container">
    <router-link to="/" class="logo">
      <Logo :width="160" :height="155" />
    </router-link>
    <ul class="nav">
      <li class="nav-item noMob">
        <span>Connect with Us!</span>
      </li>
      <li class="nav-item">
        <a class="nav-link" target="_blank" href="https://www.facebook.com/pencilsforkidsincUSA/"><i class="fa fa-facebook"></i></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" target="_blank" href="https://www.instagram.com/pencilsforkidsinc/"><i class="fa fa-instagram"></i></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" target="_blank" href="https://www.pinterest.com/PFKInc/"><i class="fa fa-pinterest-p"></i></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" target="_blank" href="https://www.youtube.com/@pencilsforkidsinc"><i class="fa fa-youtube"></i></a>
      </li>
    </ul>
  </header>
</template>

<script>
import Logo from './Logo'

export default {
  name: 'masthead',
  components: {
    Logo
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

.noMob {
  @include media('tablet-small', 'max') {
    display: none;
  }
}

.logo {
  display: block;
}
</style>



// WEBPACK FOOTER //
// Masthead.vue?65f9829e